const jQ = jQuery.noConflict();

class setupIsotopeGrid{

	constructor(selector){
		this.sel = selector;
		this.container = ".small-image-grid__content";

	}

	is_touch_device() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}

	toggleOpenItemClass(e){

		let gridItem = jQ(e.currentTarget);
		let grayscaleItem = gridItem.find(".grayscale");

		if(e.target.tagName.toLowerCase() !== 'a'){
			gridItem.toggleClass("open-item");
			if(this.is_touch_device()){
				grayscaleItem.toggleClass("grayscale-off");
			}
		}
		
	}

	init(){

		jQ(this.container).isotope({

			layoutMode: 'masonry',
			masonry: {
		 		columnWidth: '.grid-sizer',
		 		gutter: '.gutter-sizer',
		 		isFitWidth: true 
			}
			
		});

		jQ(this.sel).on("click", (e) => {

			this.toggleOpenItemClass(e);
			jQ(this.container).isotope('layout');	


		});


	}
}

const setupIsotope = new setupIsotopeGrid(".grid-item");

export default setupIsotope;


// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/setupisotopegrid.js